import { render, staticRenderFns } from "./HomeSlides.vue?vue&type=template&id=83e45cea&scoped=true&lang=pug"
import script from "./HomeSlides.vue?vue&type=script&lang=js"
export * from "./HomeSlides.vue?vue&type=script&lang=js"
import style0 from "./HomeSlides.vue?vue&type=style&index=0&id=83e45cea&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e45cea",
  null
  
)

export default component.exports